import { OAUTH_SCOPE } from './scopes';

export interface ClientMetadata {
	client_id: string;
	client_name: string;
	client_uri: string;
	logo_uri?: string;
	redirect_uris: string[];
	scope: string;
	grant_types: string[];
	response_types: string[];
	application_type: 'web' | 'native';
	token_endpoint_auth_method: string;
	dpop_bound_access_tokens: boolean;
}

export const CLIENT_METADATA_PATH = '/oauth/client-metadata.json';
export const CALLBACK_PATH = '/oauth/callback';

/**
 * Builds the OAuth client metadata document for a given public deployment URL.
 *
 * Shared between the Vite build (which emits the static
 * `/oauth/client-metadata.json`) and the runtime, so the hosted document and
 * the `client_id` the app sends always stay in sync.
 *
 * This describes a *public* client (no client secret / `token_endpoint_auth_method: none`)
 * using PKCE + DPoP. Sessions are kept alive via rotating refresh tokens.
 */
export const buildClientMetadata = (clientUri: string): ClientMetadata => {
	// Normalise: strip any trailing slash.
	const base = clientUri.replace(/\/+$/, '');

	return {
		client_id: base + CLIENT_METADATA_PATH,
		client_name: 'Skeetdeck',
		client_uri: base,
		logo_uri: base + '/favicon.png',
		redirect_uris: [base + CALLBACK_PATH],
		scope: OAUTH_SCOPE,
		grant_types: ['authorization_code', 'refresh_token'],
		response_types: ['code'],
		application_type: 'web',
		token_endpoint_auth_method: 'none',
		dpop_bound_access_tokens: true,
	};
};
